import { useContext, useRef } from 'react'
import QuestionKey from '../Questions/question-key'
import { ApplicationFormContext } from '../components/ApplicationForm/ApplicationFormContext'

/**
 * Answers the question and moves the form on, at most once per mount.
 * Used by questions that advance as soon as an option is picked (removeContinueCtaV1), where a double tap
 * would otherwise dispatch QUESTION_ANSWERED twice and skip the next question.
 * Going back to the question remounts it, which resets the guard for the new visit.
 */
export const useAutoAdvance = (name: QuestionKey): ((value: string) => void) => {
  const { dispatch } = useContext(ApplicationFormContext)
  const advanced = useRef(false)

  return (value: string) => {
    if (advanced.current) return
    advanced.current = true
    dispatch({ type: 'QUESTION_ANSWERED', name, value })
  }
}
